<template>

    <Head title="Daftar Kunjungan" />
    <Link href="/kunjungan/create" class="btn btn-primary btn-sm mb-3" v-if="isTeam">Tambah</Link>
    <div id="accordion" v-if="isTeam == false">
        <div class="card card-primary">
            <div class="card-header">
                <h4 class="card-title w-100">
                    <a class="d-block w-100" data-toggle="collapse" href="#collapseOne">
                        SARING DATA
                    </a>
                </h4>
            </div>
            <div id="collapseOne" class="collapse" data-parent="#accordion">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm">
                            <datepicker label="Tanggal Kunjungan" name="tanggal" class="fas fa-calendar-alt"
                                id="tgl_kunjungan" />
                        </div>
                        <div class="col-sm">
                            <input-select2 label="Penagihan" :options="collectors" :settings="{
                                placeholder: 'Pilih data ...',
                                allowClear: true,
                            }" name="collector" class="form-control filter-select">
                            </input-select2>
                        </div>
                        <div class="col-sm">
                            <input-text label="Kode Kantor" name="kantor" class="form-control filter-input" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="$page.props.flash.failed" class="alert">
        {{ $page.props.flash.failed }}
    </div>

    <div class="card card-outline card-primary">
        <div class="card-header">
            <h3 class="card-title">DAFTAR KUNJUNGAN</h3>
            <div class="card-tools">
                <Link href="/home" class="btn btn-tool"><i class="fas fa-times"></i></Link>
            </div>
        </div>
        <div class="card-body table-responsive">
            <div v-if="isTeam" class="card-body table-responsive">
                <data-table :columns="columnsTeam" :ajax="ajax" :order="[5, 'desc']"
                    :columnDefs="[{ targets: [1], className: 'dt-body-center' }]"></data-table>
            </div>
            <div v-else class="card-body table-responsive">
                <data-table :columns="columns" :ajax="ajax" :order="[5, 'desc']"
                    :columnDefs="[{ targets: [1], className: 'dt-body-center' }]"></data-table>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from "@/Layouts/Master"
import { Head, Link, router } from "@inertiajs/vue3"
import InputText from "@/Forms/InputText"
import InputSelect2 from "@/Forms/InputSelect2"
import InputFile from "@/Forms/InputFile"
import Datepicker from "@/Forms/Datepicker"
import DataTable from '@/Forms/DataTable'

export default {
    layout: Layout,
    components: {
        Head,
        Link,
        InputText,
        InputSelect2,
        InputFile,
        Datepicker,
        DataTable,
    },
    props: {
        collectors: Array,
        isTeam: Boolean,
        flash: Object
    },
    data() {
        return {
            columnsTeam: [
                { title: 'No', data: 'DT_RowIndex', orderable: false, searchable: false },
                { title: 'Kantor', data: 'tagihan.kantor' },
                { title: 'Rekening', data: 'rek' },
                { title: 'Nama', data: 'tagihan.nama' },
                { title: 'Alamat', data: 'tagihan.alamat' },
                { title: 'Tgl Kunjungan', data: 'created_at' },
                { title: 'Tgl Janji', data: 'tgl_janji' },
                { title: 'Keterangan', data: 'keterangan' },
                { title: 'Aksi', data: 'action', orderable: false, searchable: false, },
            ],
            columns: [
                { title: 'No', data: 'DT_RowIndex', orderable: false, searchable: false },
                { title: 'Kantor', data: 'tagihan.kantor' },
                { title: 'Rekening', data: 'rek' },
                { title: 'Nama', data: 'tagihan.nama' },
                { title: 'Alamat', data: 'tagihan.alamat' },
                { title: 'Tgl Kunjungan', data: 'created_at' },
                { title: 'Tgl Janji', data: 'tgl_janji' },
                { title: 'Keterangan', data: 'keterangan' },
                { title: 'Penagihan', data: 'user.name' },
                { title: 'Lokasi Input', data: 'koordinat' },
                { title: 'Aksi', data: 'action', orderable: false, searchable: false, },
            ],
            ajax: {
                url: '/datatables/kunjungan',
                data: function (d) {
                    d.collector = $('select[name=collector]').val()
                    d.tanggal = $('input[name=tanggal]').val()
                    d.kantor = $('input[name=kantor]').val()
                },
            },
        }
    },
    mounted() {
        $('.filter-input').keyup(function (e) {
            $("#dt-table").DataTable().ajax.reload()
            e.preventDefault();
        })
        $('.filter-select').on('change', function (e) {
            $("#dt-table").DataTable().ajax.reload()
            e.preventDefault();
        });
        $('#tgl_kunjungan').on('change', function (e) {
            $("#dt-table").DataTable().ajax.reload()
            e.preventDefault();
        });
        $('body').on('click', '.btn-delete', function (event) {
            event.preventDefault();
            let name = $(this).attr('id');
            let url = $(this).attr('href');
            Swal.fire({
                title: name,
                text: "Yakin data ini dihapus",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: 'Ya, hapus!',
                cancelButtonText: 'Batal'
            }).then((result) => {
                if (result.isConfirmed) {
                    router.delete(url, {
                        onSuccess: page => {
                            toastr.success('Hapus Kunjungan berhasil', 'SUKSES')
                            $('#dt-table').DataTable().ajax.reload();
                        },
                        onError: errors => {
                            toastr.error(errors.message, 'GAGAL')
                        },
                    })
                }
            })
        });
        $('body').on('click', '.btn-sendwa', function (event) {
            event.preventDefault();
            let name = $(this).attr('id');
            let url = $(this).attr('href');
            Swal.fire({
                title: name,
                text: "Yakin kirim ulang WA",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: '#136e28',
                confirmButtonText: 'Ya, kirim!',
                cancelButtonText: 'Batal'
            }).then((result) => {
                if (result.isConfirmed) {
                    router.delete(url, {
                        onSuccess: page => {
                            toastr.success('Kiring ulang WA berhasil', 'SUKSES')
                        },
                        onError: errors => {
                            toastr.error(errors.message, 'GAGAL')
                        },
                    })
                }
            })
        });
        $('body').on('click', '.btn-edit', function (event) {
            event.preventDefault();
            let url = $(this).attr('href');
            router.delete(url, {
                onSuccess: page => {
                },
                onError: errors => {
                    toastr.error(errors.message, 'GAGAL')
                },
            })
        });
    }
};
</script>
